import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function ConfidenceSpectrumVisual({ title, takeaway, caption, data = {} }) {
  const points = data.points || [
    { label: "Inferred", note: "Less geological evidence", x: 150 },
    { label: "Indicated", note: "Increasing confidence", x: 380 },
    { label: "Measured", note: "Greater geological confidence", x: 610 },
  ];

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption}>
      <svg viewBox="0 0 760 260" role="img" aria-label="Relative geological confidence spectrum from Inferred through Indicated to Measured resources.">
        <text x="70" y="54" fontSize="12" fontWeight="850" fill={p.muted}>LOWER</text>
        <text x="690" y="54" textAnchor="end" fontSize="12" fontWeight="850" fill={p.muted}>HIGHER</text>
        <text x="380" y="54" textAnchor="middle" fontSize="14" fontWeight="900" fill={p.ink}>Relative geological confidence</text>
        <line x1="84" y1="96" x2="676" y2="96" stroke={p.line} strokeWidth="4" />
        <path d="M676 96 l-12 -8 v16 z" fill={p.line} />
        {points.map((point, index) => (
          <g key={point.label}>
            <circle cx={point.x} cy="96" r="12" fill={index === 2 ? p.goldWash : "#fff"} stroke={index === 2 ? p.gold : p.line} strokeWidth="2" />
            <circle cx={point.x} cy="96" r="4" fill={index === 2 ? p.gold : p.muted} />
            <text x={point.x} y="142" textAnchor="middle" fontSize="14" fontWeight="900" fill={p.ink}>{point.label}</text>
            <foreignObject x={point.x - 72} y="154" width="144" height="48">
              <div xmlns="http://www.w3.org/1999/xhtml" style={{ fontSize: 12, lineHeight: 1.3, color: p.muted, textAlign: "center", fontWeight: 750 }}>
                {point.note}
              </div>
            </foreignObject>
          </g>
        ))}
        <line x1="148" y1="220" x2="612" y2="220" stroke={p.softLine} strokeWidth="3" />
        <path d="M612 220 l-10 -7 v14 z" fill={p.softLine} />
        <text x="380" y="208" textAnchor="middle" fontSize="12" fontWeight="850" fill={p.muted}>Evidence and sampling support generally strengthen</text>
      </svg>
    </LearnVisualFrame>
  );
}
